var render, staticRenderFns
import script from "./PanVerification.vue?vue&type=script&lang=js"
export * from "./PanVerification.vue?vue&type=script&lang=js"
import style0 from "./PanVerification.vue?vue&type=style&index=0&id=c279372c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports